import API from "../../../utils/API";
import {
    AUTHENTICATE_USER_FAILURE,
    AUTHENTICATE_USER_SUCCESS,
    AUTHENTICATE_USER_STARTED,
    FORGOT_PASSWORD_STARTED,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    UPDATE_PASSWORD_STARTED,
    UPDATE_PASSWORD_SUCCESS,
    UPDATE_PASSWORD_FAILURE,
    RESET_PASSWORD_STARTED,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    SEND_RESET_PASSWORD_STARTED,
    SEND_RESET_PASSWORD_SUCCESS,
    SEND_RESET_PASSWORD_FAILURE,
    CHANGE_BUSINESS_STARTED,
    CHANGE_BUSINESS_SUCCESS,
    CHANGE_BUSINESS_FAILURE,
    LOGOUT,
    REMOVE_ERROR_MESSAGE,
    UPDATE_PERMISSIONS,
} from "../../constants/authenticate/authenticate";

import Cookies from "js-cookie";

import { safeParse } from "../../../utils/utility"

const user = safeParse("user") || {
    authenticated: false,
    isRequiredChangePassword: false,
    permissions: []
};

const initialState = {
    user: user,
    loading: false,
    error: null,
    message: null,
    component: "",
};

const isSafariPWA = window.navigator.standalone === true;

/**
 * Handle Login and Logout
 * User object with token will be stored in localStorage
 * @param {*} state
 * @param {*} action
 */
export default function authenticate(state = initialState, action) {
    switch (action.type) {

        case AUTHENTICATE_USER_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };

        case AUTHENTICATE_USER_SUCCESS:
            const { staffAccount, business, token, staffId } = action.payload.data;

            if (isSafariPWA) {
                if (token) localStorage.setItem("staffAT", token);
                if (staffId) localStorage.setItem("staff", staffId.toString());

            }
            if (business) localStorage.setItem("business", business._id.toString());

            var newUser = {
                authenticated: true,
                isRequiredChangePassword: staffAccount.isRequiredChangePassword,
                permissions: staffAccount.permissions,
                allowCreateBlockTime: staffAccount.allowCreateBlockTime,
                allowCreateAppointment: staffAccount.allowCreateAppointment,
                businesses: staffAccount.businesses,
            };

            Cookies.set("staffAccount", JSON.stringify(newUser), { expires: 90 });
            localStorage.setItem("user", JSON.stringify(newUser));

            return {
                ...state,
                user: newUser,
                error: null,
                loading: false,
            };

        case AUTHENTICATE_USER_FAILURE:
            return {
                ...state,
                loading: false,
                error: "Incorrect Email or Password!",
            };
        //User logout
        //remove all the cookies
        case LOGOUT:
            if (isSafariPWA) {
                localStorage.removeItem("staffAT");
                localStorage.removeItem("staff");
                localStorage.removeItem("business");
            }
            localStorage.removeItem("user");
            Cookies.remove("staffAccount");
            delete API.defaults.headers.common["Authorization"];
            return {
                ...state,
                user: {
                    authenticated: false,
                    isRequiredChangePassword: false,
                    permissions: [],
                },
                loading: false,
                error: null,
            };
        case FORGOT_PASSWORD_STARTED:
            return {
                ...state,
                loading: true,
                message: null,
                error: null,
                component: "ForgotPassword",
            };
        case FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                message:
                    "A reset password instruction was sent to your email if it is in our database!",
            };
        case FORGOT_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                message:
                    "A reset password instruction was sent to your email if it is in our database!",
            };
        case UPDATE_PASSWORD_STARTED:
            return {
                ...state,
                loading: true,
                message: null,
                error: null,
                component: "",
            };
        case UPDATE_PASSWORD_SUCCESS:
            Cookies.remove("staffAccount");
            localStorage.clear();
            API.defaults.headers.common["Authorization"] = `Bearer `;
            return {
                ...state,
                loading: false,
                user: {
                    authenticated: false,
                    isRequiredChangePassword: false,
                    permissions: []
                },
                isRequiredActivation: false,
                message: "Your Password was updated",
            };
        case UPDATE_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: "",
            };
        case SEND_RESET_PASSWORD_STARTED:
            return {
                ...state,
                loading: true,
                message: null,
                error: null,
            };
        case SEND_RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                message: "A reset password instruction was sent to your email!",
            };
        case SEND_RESET_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                error: "There is an error. Cannot send reset password email!",
            };
        case RESET_PASSWORD_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                message:
                    "Password has been reset successfully. Please log in again!",
            };
        case RESET_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                error: "There is an error. Cannot reset your password!",
            };
        case CHANGE_BUSINESS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case CHANGE_BUSINESS_SUCCESS:
            const { business: newBusiness, staffId: newStaffId } = action.payload.data;
            if (isSafariPWA) {
                if (newStaffId) localStorage.setItem("staff", newStaffId.toString());
                if (newBusiness) localStorage.setItem("business", newBusiness._id.toString());
            }
            window.location.replace("/");

            return {
                ...state,
                loading: false,
                message: "Business has been changed successfully!",
            };
        case CHANGE_BUSINESS_FAILURE:
            return {
                ...state,
                loading: false,
                error: "There is an error. Cannot change business!",
            };

        case UPDATE_PERMISSIONS:
            return {
                ...state,
                user: {
                    ...state.user,
                    permissions: action.payload.permissions,
                },
            };

        case REMOVE_ERROR_MESSAGE:
            return {
                ...state,
                loading: false,
                error: null,
                message: null,
            };
        default:
            return { ...state };
    }
}
